import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { LinkButton } from 'ui_system/forms/buttons';
import './index.scss';
import Accepted from './accepted';
import Pending from './pending';

// TODO: refactor other separators on this page, and don't use negative margin
const Separator = styled.hr`
  background: #ccc;
  border: 0;
  height: 1px;
  margin: 50px 0 32px;

  @media only screen and (max-width: 767px) {
    margin: 14px -20px;
  }
`;

class ConfirmationBody extends React.PureComponent {
  static displayName = 'ConfirmationBody-Plugins';

  static propTypes = {
    guide_full_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    recipient_id: PropTypes.number.isRequired,
    sender_id: PropTypes.number.isRequired,
    booking_id: PropTypes.number.isRequired,
    booking_id_hash: PropTypes.string.isRequired,
    automatic_booking: PropTypes.bool.isRequired,
    footer_content: PropTypes.node.isRequired,
    first_name: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    booking_redirect_url: PropTypes.string,
    tour: PropTypes.object,
    brand_color: PropTypes.string,
    ticketed_event: PropTypes.bool.isRequired,
    has_multiple_tickets: PropTypes.bool.isRequired,
    online: PropTypes.bool,
    tour_timezone: PropTypes.string,
    is_live_booking: PropTypes.bool,
    isBookingAffiliate: PropTypes.bool,
    isBookingPaid: PropTypes.bool,
  };

  viewComponent = () => {
    const {
      automatic_booking,
      guest_paid_invoice,
      isBookingAffiliate,
      isBookingPaid,
      isBookingPending,
    } = this.props;
    const affiliatePaidBooking =
      isBookingAffiliate && isBookingPaid && !isBookingPending;
    const showAccepted =
      automatic_booking || guest_paid_invoice || affiliatePaidBooking;
    const Component = showAccepted ? Accepted : Pending;

    return <Component {...this.props} />;
  };

  render() {
    const { affiliate_portal_link } = this.props;

    return (
      <>
        {this.viewComponent()}
        {affiliate_portal_link && (
          <>
            <Separator />
            <LinkButton
              data-testid="book-another-experience"
              href={affiliate_portal_link}
              target="_parent"
              className="brand-bg brand-border"
            >
              Book another experience
            </LinkButton>
          </>
        )}
      </>
    );
  }
}

export default ConfirmationBody;
